module.exports = __webpack_public_path__ + "img/BND.0cbb1978.svg";